// @flow

import * as React from "react"
import {connect} from "react-redux"
import ClassNames from "classnames"

import BabyCard from "./baby-card"
import {fetchBabiesPaged, setBabiesPage} from "../actions/babies"
import type {Dispatch, State as ReduxState, Baby} from "../types"

type Props = {
  dispatch: Dispatch,
  babies: $ReadOnlyArray<Baby>,
  babiesState: BabiesState,
  isAdmin: boolean,
}

class BabyCardList extends React.Component<Props> {
  static defaultProps = {
    isAdmin: false,
  }

  onPrevious: (e: React.MouseEvent<HTMLButtonElement>) => void = (e) => {
    e.preventDefault()
    this.props.dispatch(setBabiesPage(this.props.babiesState.page - 1))
    this.props.dispatch(fetchBabiesPaged())
  }

  onNext: (e: React.MouseEvent<HTMLButtonElement>) => void = (e) => {
    e.preventDefault()
    this.props.dispatch(setBabiesPage(this.props.babiesState.page + 1))
    this.props.dispatch(fetchBabiesPaged())
  }

  renderPagination() {
    const {babies, babiesState} = this.props
    if (babies.length == 0)
      return (
        <span className="text-muted text-sm font-italic">
          None found or still loading ...
        </span>
      )
    const canPrevious = babiesState.page > 1
    const canNext = babiesState.page < babiesState.totalPages
    const previousClassNames = ClassNames("", {
      active: !canPrevious,
    })
    const nextClassNames = ClassNames("", {
      active: !canNext,
    })
    return (
      <div className="d-flex justify-content-center mt-4">
        <nav>
          <ul className="pagination">
            <li className={previousClassNames} key="prev">
              <a
                className=""
                rel="previous"
                href="#"
                onClick={
                  canPrevious
                    ? this.onPrevious
                    : (e) => {
                        e.preventDefault()
                      }
                }
              >
                ‹
              </a>
            </li>
            <li>
              <span>
                {babiesState.page} / {babiesState.totalPages}
              </span>
            </li>
            <li className={nextClassNames} key="next">
              <a
                className=""
                rel="next"
                href="#"
                onClick={
                  canNext
                    ? this.onNext
                    : (e) => {
                        e.preventDefault()
                      }
                }
              >
                ›
              </a>
            </li>
          </ul>
        </nav>
      </div>
    )
  }

  render() {
    const {babies, isAdmin} = this.props
    if (babies.length == 0)
      return (
        <span className="text-muted text-sm font-italic">
          None found or still loading ...
        </span>
      )
    return (
      <div>
        {this.renderPagination()}
        <ul className="baby-card-list">
          {babies.map((baby) => (
            <li
              className="baby-card-list-item"
              key={`baby-card-list-item-${baby.token}`}
            >
              <BabyCard baby={baby} isAdmin={isAdmin} />
            </li>
          ))}
        </ul>

        {this.renderPagination()}
      </div>
    )
  }
}

const mapStateToProps = (state: ReduxState) => ({
  babiesState: state.babies,
})

export default connect(mapStateToProps)(BabyCardList)
